<h2 class="popup-heading" mat-dialog-title>{{ data.map ? 'Edit' : 'Add' }} Map</h2>
<form (ngSubmit)="submitForm($event)" [formGroup]="form">
  <mat-dialog-content class="mat-typography">
    <div class="errors">
      @for (error of errors | keyvalue; track error) {
        <span>{{ error.value }}</span>
      }
    </div>
    <mat-form-field appearance="fill">
      <mat-label>Select the firework type</mat-label>
      <mat-select [formControl]="form.controls.firework_type_id" required>
        @for (type of types; track type) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Your Category</mat-label>
      <input matInput [formControl]="form.controls.name" required>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="cancel-popup" mat-button mat-dialog-close [disabled]="processing">Cancel</button>
    <button class="popup-save" mat-button type="submit" cdkFocusInitial [disabled]="processing">
      Save
      @if (processing) {
        <mat-icon>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      }
    </button>
  </mat-dialog-actions>
</form>